<section class="callback-container">
  <mat-card class="mat-elevation-z6">
    <div class="content">
      <div class="img-container">
        <img
          src="https://lcptracker.com/wp-content/uploads/2024/03/LCPtracker-TM-Logo-Full-Color-cropped.png"
          width="175"
          alt="LCPtracker Logo"
        />
      </div>
      <div class="loading">
        <mat-progress-spinner
          class="example-margin"
          color="primary"
          mode="indeterminate"
          diameter="50"
        >
        </mat-progress-spinner>
      </div>
      <h4>Welcome to Wage Data Module</h4>
      <p>
        We're finalizing the details before granting access to the Dashboard.
      </p>
    </div>
  </mat-card>
</section>
